import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import Modal from 'react-modal';
import ProjectSelect from 'components/core/ProjectSelect';
import Alert from 'components/shared/DesignSystem/Alert';
import { Button } from '@companycam/slab-web';

const ErrorAlert = styled(Alert)`
  margin-top: 18px;
`;

const ReassignPhotosModal = ({
  onReassignClicked,
  isOpen,
  onRequestClose,
  companyId,
  errorMessage,
}) => {
  const [state, setState] = useState({ projectId: null, projectNodeId: null });

  const onSaveClick = () => {
    if (state.projectId && state.projectNodeId) {
      const { projectId, projectNodeId } = state;
      onReassignClicked({ projectId, projectNodeId });
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      contentLabel="Reassign photos"
      overlayClassName="modal"
      className="modal-content-wrap min-height"
    >
      <button
        type="button"
        className="modal-close-button"
        onClick={onRequestClose}
      >
        <i className="mdi mdi-close" />
      </button>
      <h3 className="modal-title">
        <FormattedMessage
          id="Photos.reassignPhotosModal.title"
          defaultMessage="Move Photos"
          description="section header"
        />
      </h3>
      <form>
        <span className="instructions">
          <FormattedMessage
            id="Photos.reassignPhotosModal.instructions"
            defaultMessage="Select which project you would like to move the selected photos to."
            description="message to the user describing the adjacent select input"
          />
        </span>
        <ProjectSelect
          companyId={companyId}
          initialValue={state.projectId}
          onChange={(project) => {
            setState({
              projectId: project ? project.id : null,
              projectNodeId: project ? project.node_id : null,
            });
          }}
        />
        <div className="btn-container">
          <Button color="primary" type="button" onClick={onSaveClick}>
            <FormattedMessage
              id="Photos.reassignPhotosModal.movePhotos"
              defaultMessage="Move Photos"
              description="Button that allows the user to submit and move photos"
            />
          </Button>
        </div>
        {errorMessage ? (
          <ErrorAlert flavor="destroy" showBorder>
            {errorMessage}
          </ErrorAlert>
        ) : null}
      </form>
    </Modal>
  );
};

ReassignPhotosModal.propTypes = {
  companyId: PropTypes.number,
  onReassignClicked: PropTypes.func,
  onRequestClose: PropTypes.func,
  isOpen: PropTypes.bool,
  errorMessage: PropTypes.string,
};

ReassignPhotosModal.defaultProps = {
  onReassignClicked: () => {},
  onRequestClose: () => {},
  isOpen: false,
};

export default ReassignPhotosModal;
